import { useFee } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import Badge from '../../Badge.js';
import CopyToClipboard from '../../CopyToClipboard.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import Table from '../../Table.js';
const ParkingLot = (props) => {
    const { caseVoucher } = props;
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    console.log(fee);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(feeLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            h.hasData(feeLoadable) && fee ? (React.createElement(React.Fragment, null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", null, "Pladsnummer"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, { text: fee.parkingLotCode },
                                React.createElement("b", null, fee.parkingLotCode)))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Adresse"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, null, fee.parkingLotAddress),
                            React.createElement("br", null),
                            fee.parkingLotAddress2 ? (React.createElement(React.Fragment, null,
                                React.createElement(CopyToClipboard, null, fee.parkingLotAddress2),
                                React.createElement("br", null))) : null,
                            fee.parkingLotPostCode,
                            " ",
                            fee.parkingLotCity)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Skilt opsat"),
                        React.createElement("td", null, moment(fee.pSignSetupDate).format(THEME.DATE_FORMAT_SHORT))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Plads opsat"),
                        React.createElement("td", null, moment(fee.parkingLotStartingDate).format(THEME.DATE_FORMAT_SHORT))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Observationstid"),
                        React.createElement("td", null,
                            fee.parkingLotObsTimeMin,
                            " min.")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Ekspert"),
                        React.createElement("td", null, fee.parkingLotExpert || '-')),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Driftsansvarlig"),
                        React.createElement("td", null, fee.parkingLotOperatingResponsible || '-')),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Pladsekspert"),
                        React.createElement("td", null, fee.parkingLotExpert || '-')),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Easypark id"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, null, fee.easyparkId || '-'))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Flow id"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, null, fee.flowId || '-')))),
                React.createElement("div", { style: { marginTop: '10px' } },
                    fee.anprLot ? (React.createElement(Badge, { style: { margin: '0 5px 0 0' }, theme: THEME.COLOR_ACCENT }, "ANPR-l\u00F8sning")) : null,
                    fee.tabletSolution ? (React.createElement(Badge, { style: { margin: '0 5px 0 0' }, theme: THEME.COLOR_ACCENT }, "Tablet-l\u00F8sning")) : null,
                    fee.staffSolution ? (React.createElement(Badge, { style: { margin: '0 5px 0 0' }, theme: THEME.COLOR_ACCENT }, "Personale-l\u00F8sning")) : null,
                    fee.receptionSolution ? (React.createElement(Badge, { style: { margin: '0 5px 0 0' }, theme: THEME.COLOR_ACCENT }, "Receptions-l\u00F8sning")) : null,
                    fee.parkingLotInactive ? (React.createElement(Badge, { style: { margin: '0 5px 0 0' }, theme: THEME.DANGEROUS }, "Plads inaktiv")) : null))) : (!h.isError(feeLoadable) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" })))))));
};
export default ParkingLot;
//# sourceMappingURL=ParkingLot.js.map